import React from "react";
import { withStyles } from "@material-ui/core/styles";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

const BlackCheckbox = withStyles({
  root: {
    color: "black",
    "&$checked": {
      color: "black"
    }
  },
  checked: {}
})((props) => <Checkbox color="default" {...props} />);

export default function CheckboxPanel(props) {
  const [state, setState] = React.useState({
    checkedA: false,
    checkedG: false
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });

    // eslint-disable-next-line eqeqeq
    props.update([event.target.name] == "checkedG" && event.target.checked);
  };

  return (
    <div>
      <FormGroup>
        <FormControlLabel
          control={
            <BlackCheckbox data-testid="checkbox" checked={state.checkedG} onChange={handleChange} name="checkedG" />
          }
          label={
            <Typography
              style={{
                fontSize: "16px",
                color: "black",
                textAlign: "left",
                fontFamily: "Lato",
                fontWeight: 400
              }}
            >
              Ich habe die&nbsp;
              <Link
                underline="always"
                style={{
                  color: "black",
                  fontSize: "16px",
                  textAlign: "left"
                }}
                target="_blank"
                href="https://www.ozg-hub.de/datenschutz"
              >
                Datenschutzerklärung
              </Link>{" "}
              gelesen und willige ein, dass meine Daten und die von mir gemachten Angaben zur Bearbeitung meiner Anfrage
              verarbeitet werden.*
            </Typography>
          }
        />
      </FormGroup>
    </div>
  );
}
